export default {
    computed: {
        isOffersAccepted() {
            return this.userData.role === 'borrower' ? (this.isAgreeWithServiceRules &&
                this.isAgreeWithServiceAgreement) : (this.isAgreeWithServiceAgreement &&
                    this.isAgreeWithServiceRules);
        }
    }
}